import { useContext, useEffect, useState } from "react"
import Masthead from "../Components/Masthead"
import SignIn from "../Components/SignInCard"
import SignUp from "../Components/SignUpCard"
import StoryBoard from "../Components/StoryBoard"
import exportToPDF from "../Utilities/exportStoryboardToPDF"
import saveStoryboard from "../Services/saveStoryboard"
import './StoryBoardPage.css'
import { useNavigate } from "react-router-dom"
import handleNavigation from '../Components/handleNavigate';
import ConfirmModal from "../Components/ConfirmModal"
import AlertModal from "../Components/AlertModal"
import ForgotPasswordCard from "../Components/ForgotPasswordCard"
import PurchaseTokensCard from "../Components/PurchaseTokensCard"
import useInactivityTimeout from "../Utilities/useInactivityTimeout"
import {Button, Modal, Checkbox} from '@nxtvid/component-library'
import ListOfCharacters from "../Components/ListOfCharacters"
import { CharacterContext } from "../Contexts/CharacterContext"
import { StoryboardStateContext } from "../Contexts/StoryboardStateContext"
import { StoryboardsContext } from "../Contexts/StoryboardsContext"
import { SignUpInfoContext } from "../Contexts/SignUpInfoContext"
import { AuthContext } from "../Contexts/AuthContext"
import { UserContext } from "../Contexts/UserContext"
import { ImageIndexContext } from "../Contexts/ImageIndexContext"
import { IsDisabledContext } from "../Contexts/IsDisabledContext"

const StoryBoardPage = ()=>{
  const {isAuthenticated, setIsAuthenticated} = useContext(AuthContext)
  const {userInfo, setUserInfo} = useContext(UserContext)
  const {characters, setCharacters} = useContext(CharacterContext) 
  const {storyboardState, setStoryboardState} = useContext(StoryboardStateContext)
  const {storyboards, setStoryboards} = useContext(StoryboardsContext)
  const {signUpInfo, setSignUpInfo} = useContext(SignUpInfoContext)
  const {isDisabled, setIsDisabled} = useContext(IsDisabledContext)
  const {imageIndex, setImageIndex} = useContext(ImageIndexContext)
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  const [isComplete, setIsComplete] = useState(false)
  const [isCharacterListOpen, setIsCharacterListOpen] = useState(false)
  const placeholderImage = require('../Images/image_generation_placeholder.jpg')
  const export_icon = require('../Images/export-icon.png')
  const save_icon = require('../Images/save-icon.png')
  const back_icon = require('../Images/back-icon.png')
  const character_icon = require('../Images/character-icon.png')
  const navigate = useNavigate();
  useInactivityTimeout(21600000, 'cooppStoryboardGenerator_AuthToken');
  const [isStoryboardLoaded, setIsStoryboardLoaded] = useState(false)

  // Modal States
        const [isModalOpen, setIsModalOpen] = useState(false)
        const [modalType, setModalType] = useState('confirm')
        const [modalSize, setModalSize] = useState('medium')
        const [modalTitle, setModalTitle] = useState('')
        const [modalDescription, setModalDescription] = useState('' )
        const [modalOnConfirm, setModalOnConfirm] = useState(() => () => {})
        const [modalOnCancel, setModalOnCancel] = useState(() => () => {})
        const [modalConfirmButtonText, setModalConfirmButtonText] = useState('')
        const [modalCancelButtonText, setModalCancelButtonText] = useState('')
        const [canEdit, setCanEdit] = useState(false)


        const query = new URLSearchParams(window.location.search);
        const projectId = query.get("projectId");
        
        useEffect(() => {
          if (isAuthenticated === null || !userInfo) return;
          if (storyboardState.storyboardState === 'Not Started') return
          if (isStoryboardLoaded) return
          setIsStoryboardLoaded(true)
        
          if (!projectId) {
            window.location.href = "/";
            return;
          }         
        
          const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";
        
          fetch(`${API_BASE_URL}/api/getProject`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
            },
            body: JSON.stringify({ projectId, userId: userInfo._id }),
          })
            .then(async res => {
              if (res.status === 400) {
                setIsModalOpen(true)
                setModalType("alert")
                setModalTitle("Error")
                setModalDescription("This project does not exist.")
                setModalSize("medium")
                setModalOnConfirm(() => () => {
                  setIsModalOpen(false);
                  navigate("/");
                });
                setModalOnCancel(() => () => {
                  setIsModalOpen(false);
                  navigate("/");
                });
                setModalConfirmButtonText("OK")
                setModalCancelButtonText("Cancel")
                
              }
        
              if (res.status === 403) {
                setIsModalOpen(true)
                setModalType("alert")
                setModalTitle("Error")
                setModalDescription("You do not have access to this project.")
                setModalSize("medium")
                setModalOnConfirm(() => () => {
                  setIsModalOpen(false);
                  navigate("/");
                });
                setModalOnCancel(() => () => {
                  setIsModalOpen(false);
                  navigate("/");
                });
                setModalConfirmButtonText("OK")
                setModalCancelButtonText("Cancel")
                
              }
        
              if (!res.ok) throw new Error("Failed to fetch project");
        
              const { project, access } = await res.json();
              setStoryboardState(project);
              setCanEdit(access === "editor");
            })
            .catch(err => {
              console.error("Error loading project:", err);
            });
        }, [projectId, userInfo]);
        
        
  

  const handleResize = () =>{
    setWindowWidth(window.innerWidth)
  }

  useEffect(()=>{
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);  // Clean up the event listener
    };
  }, [])

  useEffect(() => {
    setIsComplete(storyboardState.storyboardState === 'Complete');
  }, [storyboardState.storyboardState]);

  useEffect(() => { 
          if (isAuthenticated === null) return; 
      
          if (userInfo.isVideographer === null) {
            window.location.href = '/';
          }
        }, [userInfo]);


const handleConfirmLeavePage = () =>{
  setIsModalOpen(true)
  setModalTitle("Back to Home")
  setModalDescription("Are you sure you want to leave this page? Your work won't automatically be saved.")
  setModalType("confirm")
  setModalSize("medium")
  setModalOnConfirm(() => () => {
    setIsModalOpen(false);
    handleNavigation({path: "/", navigate});
  });
  setModalOnCancel(() => () => {
    setIsModalOpen(false);
  });
  setModalConfirmButtonText("Go to Home")
  setModalCancelButtonText("Cancel")
}

const handleSaveStoryboard = async () =>{
  let result = null
  if(storyboardState.storyboardState === 'Not Started' || !storyboardState.storyboardState){
    const newStoryboardState = {...storyboardState}
    newStoryboardState.storyboardState = 'In Progress'
    setStoryboardState(newStoryboardState)
    result = await saveStoryboard(newStoryboardState);
  }
  else if (isComplete && storyboardState.storyboardState !== 'Complete'){
    const newStoryboardState = {...storyboardState}
    newStoryboardState.storyboardState = 'Complete'
    setStoryboardState(newStoryboardState)
    result = await saveStoryboard(newStoryboardState);
  }
  else if (!isComplete && storyboardState.storyboardState !== 'In Progress'){
    const newStoryboardState = {...storyboardState}
    newStoryboardState.storyboardState = 'In Progress'
    setStoryboardState(newStoryboardState)
    result = await saveStoryboard(newStoryboardState); 
  }
  else{
    result = await saveStoryboard(storyboardState); 
  }
  setIsModalOpen(true)
  setModalType("alert")
  result === 'Success' ? setModalTitle("Storyboard Saved") : setModalTitle("Error")
  result === 'Success' ? setModalDescription("Your storyboard has been saved successfully!") : setModalDescription("There was an error saving your storyboard. Please try again.")
  setModalSize("medium")
  setModalOnConfirm(() => () => {
    setIsModalOpen(false);
  });
  setModalOnCancel(() => () => {
    setIsModalOpen(false);
  })
  setModalConfirmButtonText("OK")
}

    return(
      <div className="App">
      {isModalOpen ? <Modal size={modalSize} type={modalType} title={modalTitle} description={modalDescription} onConfirm={modalOnConfirm} onClose={modalOnCancel} confirm_button_text={modalConfirmButtonText} cancel_button_text={modalCancelButtonText}/> : <p></p>}
      <body className = "storyboard-body">
      <div className="background-shades" onClick={(e)=>{e.target.style.display='none'; document.getElementsByClassName("sign-in-card")[0].style.display='none'; document.getElementsByClassName("sign-up-card")[0].style.display='none'; document.getElementsByClassName("forgot-password-card")[0].style.display='none';document.getElementsByClassName("purchase-tokens-card")[0].style.display='none'; document.getElementsByClassName('sign-in-notification-message')[0].innerHTML=''; document.getElementsByClassName('sign-up-notification-message')[0].innerHTML=''; }}/>
      {isCharacterListOpen ?<div className='Characters-Dashboard-Container-StoryboardPage' onClick = {(e)=>{e.stopPropagation(); setIsCharacterListOpen(false);}}>
             <div className="Characters-Dashboard-StoryboardPage" onClick={(e)=>{e.stopPropagation();}}>
              <div className="Dashboard-Header">
              <h3 >Characters</h3>
              <p className="close-button" onClick={()=>setIsCharacterListOpen(false)}>&#10060;&#xfe0e;</p>
              </div>
              <ListOfCharacters characters={characters} setCharacters={setCharacters}setIsModalOpen={setIsModalOpen} />
            </div>
          </div>:null}
      
      

       
    <div className="storyboardPage-Header">
    <div className='left-side-details'>
      <h3 className="storyboardPage-ProjectTitle">{storyboardState.projectTitle}</h3>
      <Button toolTipMessage='Back to Dashboard' className='backToDashboardButton-Storyboard' onClick={()=>handleConfirmLeavePage()} label={windowWidth > 900 ? "Back to Dashboard":''} icon = {windowWidth > 900 ? "" : back_icon} type='primary' size ={windowWidth > 900 ? 'medium' : 'small'}/>
      
      </div>
          <div className='right-side-buttons'>
        <Button toolTipMessage='Save Storyboard' className="Save-Storyboard-Button" onClick={handleSaveStoryboard} type='primary' size ={windowWidth > 1249 ? 'medium' : 'small'} label={windowWidth > 1249 ? 'Save Storyboard' : ""} icon={windowWidth > 1249 ? "" : save_icon}/>
        <Button toolTipMessage = 'Export Storyboard to PDF' className="Export-Storyboard-Button" onClick={()=>exportToPDF(storyboardState)} type='primary' size ={windowWidth > 1249 ? 'medium' : 'small'} label={windowWidth > 1249 ? 'Export Storyboard' : ""} icon={windowWidth > 1249 ? "" : export_icon}/>
        <Button toolTipMessage='Open Character Menu' className='View-Character-Button' onClick = {()=>{setIsCharacterListOpen(true)}} label={windowWidth > 1249 ? 'Character Menu' : ''} size ={windowWidth > 1249 ? 'medium' : 'small'} type='primary'  icon={windowWidth > 1249 ? "" : character_icon}/>
        </div>
        
    </div>
      <div className="storyboard-is-complete-container">
        <Checkbox isChecked={isComplete} setIsChecked = {setIsComplete} className = 'storyboard-is-complete-checkbox'/>
        <p>Completed?</p>
      </div>
        <StoryBoard   setImageIndex = {setImageIndex} imageIndex={imageIndex} placeholderImage={placeholderImage} storyboardState = {storyboardState} setStoryboardState = {setStoryboardState} characters={characters} setCharacters={setCharacters} userInfo = {userInfo} windowWidth={windowWidth} isDisabled={isDisabled} setIsDisabled={setIsDisabled}/>
      </body>
    </div>
    )
}

export default StoryBoardPage